const footer = {
  brand: {
    description:
      "Ποιοτική οδοντιατρική φροντίδα στη Σόφια, Βουλγαρία. Συνδυάζουμε προηγμένη τεχνολογία με εξατομικευμένες θεραπείες για να σας προσφέρουμε το χαμόγελο που αξίζετε.",
  },
  quickLinks: {
    title: "Γρήγοροι Σύνδεσμοι",
    home: "Αρχική",
    about: "Σχετικά με Εμάς",
    services: "Υπηρεσίες",
    testimonials: "Ευχαριστημένοι Πελάτες",
    gallery: "Γκαλερί",
    contact: "Επικοινωνία",
  },
  services: {
    title: "Οι Υπηρεσίες Μας",
    list: {
      implantology: "Εμφυτευματολογία",
      endodontics: "Ενδοδοντία",
      "oral-surgery": "Στοματική Χειρουργική",
      periodontology: "Περιοδοντολογία",
      orthodontics: "Ορθοδοντική",
      prosthetics: "Προσθετική",
    },
  },
  questions: {
    title: "Έχετε Ερωτήσεις;",
    description:
      "Είμαστε εδώ για να βοηθήσουμε! Επικοινωνήστε μαζί μας για οποιαδήποτε ερώτηση σχετικά με τις οδοντιατρικές μας υπηρεσίες ή για να προγραμματίσετε ένα ραντεβού.",
    buttonLabel: "Επικοινωνήστε Μαζί Μας",
  },
  bottom: {
    copyright: "© {{year}} Elite Dental Solutions. Με επιφύλαξη κάθε δικαιώματος.",
  },
  legal: {
    privacyPolicy: "Πολιτική Απορρήτου",
    termsOfService: "Όροι Χρήσης",
  },
};

export default footer;
